import { render, staticRenderFns } from "./DeviceManagementView.vue?vue&type=template&id=55e5d22a&scoped=true&"
import script from "./DeviceManagementView.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementView.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagementView.vue?vue&type=style&index=0&id=55e5d22a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5d22a",
  null
  
)

export default component.exports